<template>
  <el-card>
    <el-row class="actor_migrate__title">迁移配置</el-row>
    <!-- 搜索 -->
    <el-row class="actor_migrate__search">
      <span>rid:</span>
      <el-input
        type="text"
        style="width: 200px"
        v-model="search.rid"
        placeholder="请输入rid"
      />
      <span>迁移后账号:</span>
      <el-input
        type="text"
        style="width: 200px"
        v-model="search.loginUid"
        placeholder="请输入loginUid"
      />
      <span>设备号:</span>
      <el-input
        type="text"
        style="width: 200px"
        v-model="search.imei"
        placeholder="请输入imei"
      />
      <el-button style="margin-left: 10px" type="primary" @click="getInfo"
        >搜索</el-button
      >
      <el-button style="margin-left: 10px" type="danger" @click="deletemi"
        >删除</el-button
      >
    </el-row>
    <el-row class="actor_migrate__search">
      <span>source rid:</span>
      <el-input
        type="text"
        style="width: 200px"
        v-model="rid"
        placeholder="请输入rid"
      />
      <el-button style="margin-left: 10px" type="primary" @click="getSource(1)"
        >搜索</el-button
      >
      <el-button style="margin-left: 10px" type="primary" @click="getSource(2)"
        >批量搜索</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-table
      border
      :data="tableList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="日志ID" prop="id" align="center">
      </el-table-column>
      <el-table-column label="用户UID" prop="uid" align="center">
      </el-table-column>
      <el-table-column label="角色ID" prop="rid" align="center">
      </el-table-column>
      <el-table-column label="迁移后账号" prop="loginUid" align="center">
      </el-table-column>
      <el-table-column label="迁移前账号" prop="oldLoginUid" align="center">
      </el-table-column>
      <el-table-column label="设备号" prop="imei" align="center">
      </el-table-column>
      <el-table-column label="来源" prop="source" align="center">
      </el-table-column>
      <el-table-column label="错误码" prop="errorCode" align="center">
      </el-table-column>
      <el-table-column label="错误信息" prop="errorMsg" align="center">
      </el-table-column>
      <el-table-column label="归因信息" prop="attribution" align="center">
      </el-table-column>
      <el-table-column
        prop="mtime"
        label="创建时间"
        align="center"
        :formatter="formatDate"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button @click="deleteInfo(scope.row.id)" type="info"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 配置弹窗 -->
    <el-dialog :visible.sync="isShow" title="source">
      <el-row class="actor_migrate__search">
        <span>source rid:</span>
        <el-input
          type="text"
          style="width: 200px"
          v-model="rid"
          placeholder="请输入rid"
        />
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="getSource(1)"
          >搜索</el-button
        >
      </el-row>
      <!-- 表格 -->
      <el-table border :data="sourceList">
        <el-table-column label="key" prop="key" align="center">
        </el-table-column>
        <el-table-column label="来源" prop="source" align="center">
        </el-table-column>
        <el-table-column label="推广媒介" prop="medium" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-card>
</template>

<script>
import { data } from 'jquery'

export default {
  data() {
    return {
      search: {
        rid: null,
        loginUid: '',
        imei: '',
      },
      tableList: [],
      sourceList: [],
      ridList: [],
      rid: null,
      isShow: false,
    }
  },
  methods: {
    //格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    // 获取基本数据
    async getInfo() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.actor_migrate_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          ...this.search,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('查询成功')
        this.tableList = res.data
      }
    },
    // 删除设备号
    async deletemi() {
      if(!this.search.rid && !this.search.imei){
        return this.$message.error("请输入rid或者设备号")
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.actor_migrate_delete2,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          keyWords:this.search.rid ||this.search.imei
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('删除成功')
      }
    },
    handleSelectionChange(val) {
      this.ridList = val
    },
    getSource(type) {
      let list = []
      if (type == 1) {
        list.push(this.rid)
      } else {
        list = this.ridList.map((item) => item.rid)
      }
      this.getactorSourceInfo(list)
    },
    async getactorSourceInfo(list) {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.actor_source_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          ridList: list,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('查询成功')
        this.sourceList = res.data.actorSourceBOList.map((item) => {
          return {
            key: item.key,
            source: item.actorSourceBO.actorSourceData.source,
            medium: item.actorSourceBO.actorSourceData.medium,
          }
        })
        this.isShow = true
      }
    },
    async deleteInfo(id) {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.actor_migrate_delete,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          id,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$.$message.success('删除成功')
        this.getInfo()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.actor_migrate {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>